import { getUserMetadata } from "./getUserMetadata";
import { recordProfileVisit } from "./recordProfileVisit";
import { rememberPwaUse } from "./rememberPwaUse";

export const metadataAPI = {
  getUserMetadata,
  recordProfileVisit,
  rememberPwaUse,
};

export type MetadataAPI = typeof metadataAPI;
